import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {User} from '../models/user.model';
import {AuthService} from '../services/auth.service';
import {ROLE} from '../const/mock-selectize-config';


/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({selector: '[isJobSeeker]'})
export class IsJobSeekerDirective {
  private hasView: boolean = false;
  private user: User;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService) {

    this.authService.getAuth().subscribe((auth) => {
      this.user = auth.user;
      this.checkJobSeeker(this.user);
    });
  }

  private checkJobSeeker(user: User) {
    if (user) {
      for (let r of user.role) {
        if (r.name == ROLE.jobSeeker && !this.hasView) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView = true;
          return;
        } else if (r.name != ROLE.jobSeeker && this.hasView) {
          this.viewContainer.clear();
          this.hasView = false;
        }
      }
    } else {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }
}
